<ul>
  <li>
    <div><span>Carry out a simple blood test at home and pop it in the post.</span></div>
    <div><img src="./images/h1.svg" alt=""></div>
  </li>
  <li>
    <div><span>Talk through your results on a video call with a women’s health specialist.</span></div>
    <div><img src="./images/h2.svg" alt=""></div>
  </li>
  <li>
    <div><span>Receive a tailored care plan that tackles symptoms and helps prevent future problems.</span></div>
    <div><img src="./images/h3.svg" alt=""></div>
  </li>
</ul>

<style>
  ul {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0 -2rem;
    list-style: none;
  }

  li {
    display: flex;
  }

  li:nth-child(even) {
    flex-direction: row-reverse;
  }

  div {
    flex: 0 1 50%;
    display: flex;
    padding: 1rem;
  }

  span {
    margin: auto;
    font-family: var(--ff-2);
    font-size: min(2.25rem, calc(8px + 2.5vw));
    max-width: 13.5ch;
  }

  img {
    max-width: 100%;
    align-self: center;
    width: 80%;
    margin: auto;
  }
</style>